import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Card from "../components/card";
import Header from "../components/header";
import AppLayout from "../components/AppLayout";
import { Pie } from "@ant-design/plots";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import {
  addAppointment,
  addBusinessPatients,
  addServiceDashboard,
  addStaffDashboard,
  addbusinessAppointment,
  getActivityLogs,
  getBusinessAppointment,
  getBusinessPatients,
  getBusinessDashboard,
  getBusinessDetails,
  getBusinessProfile,
  getBusinessServices,
  getBusinessStaff,
  getBusinessStaffAll,
} from "../logic/business/action";
import { IoExpandOutline } from "react-icons/io5";
import QRCode from "react-qr-code";
import {
  MdAdd,
  MdArrowBackIos,
  MdArrowForwardIos,
  MdCalendarMonth,
  MdCalendarToday,
  MdClose,
  MdCopyAll,
  MdDelete,
  MdExitToApp,
  MdLogout,
  MdPeople,
  MdPerson,
  MdPersonAdd,
  MdSettings,
  MdShare,
  MdSearch,
  MdAttachMoney,
  MdTrendingUp,
  MdTrendingDown,
  MdCheckCircle,
  MdCancel,
  MdSchedule,
  MdAccessTime,
} from "react-icons/md";
import { CopyToClipboard } from "react-copy-to-clipboard";
import InputComponents from "../components/input";
import moment from "moment";
import { getColorsByType, getIconsByType } from "../utils/activity_utils";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import dayjs from "dayjs";

import { RWebShare } from "react-web-share";

import { toast } from "react-toastify";
import {
  DateField,
  DatePicker,
  MobileDatePicker,
  TimeField,
} from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import {
  Avatar,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Pagination,
  Snackbar,
  Tab,
  Tabs,
  Typography,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import {
  failedBookAppointment,
  failedBusinessCustomers,
  filterAppointmentByStaff,
  removeAppointmentError,
  resetAppointment,
} from "../logic/business/reducer";
import FormikForm from "../components/commonForm";
import {
  feildsAddStaff,
  initialValuesAddStaff,
  validationSchemaAddStaff,
} from "../fromsUtil/addStaff";
import {
  feildsAddCustomer,
  initialValuesAddCustomer,
  validationSchemaAddCustomer,
} from "../fromsUtil/addPatient";
import { IoMenu } from "react-icons/io5";
import Drawer from "../components/drawer";
import formatNumber from "../utils/convertNumbers";
import { deleteAccount, logOut } from "../logic/login/action";
import { setDate, setSelectedDate } from "../logic/dates/reducer";
import {
  addDate,
  removeDate,
  setInitialDate,
  setInitialMobileDate,
} from "../logic/dates/action";
import {
  compareDate,
  compareTime,
  getADayFromNow,
  returnMonth,
  returnStaffColor,
  returnWeek,
  timeLine,
} from "../utils/date";
import { getAccounts } from "../logic/accounts/action";
import { successMessage } from "../logic/error/action";
import { PATIENTS } from "../utils/urls";
import {
  FaEnvelope,
  FaFacebookF,
  FaInstagram,
  FaTelegramPlane,
  FaWhatsapp,
} from "react-icons/fa";
import PopupCallButton from "../components/PopupCallButton/PopupCallButton";
import Popup from "../components/Popup/Popup";
import { RxCross2 } from "react-icons/rx";
import { TextField } from "@mui/material";
import { useTenant } from "../context/TenantContext";
import { useLabels } from "../utils/labels";

const Home = () => {
  const selector = useSelector((state) => state.business);
  const selectorAuth = useSelector((state) => state.auth);
  const { tenant } = useTenant();
  const labels = useLabels();
  const [dateselected, setdateselected] = useState(
    `${new Date().getFullYear()}-${
      new Date().getMonth() + 1
    }-${new Date().getDate()}`
  );
  const dispatch = useDispatch();
  const [serviceDrop, setserviceDrop] = useState(false);

  const toggleserviceDropdown = () => {
    setserviceDrop((prev) => !prev);
  };

  const [shareDrop, setshareDrop] = useState(false);

  const toggleshareDropdown = () => {
    setshareDrop((prev) => !prev);
  };
  const [appointmentDrop, setappointmentDrop] = useState(false);

  const toggleappointmentDropdown = () => {
    setappointmentDrop((prev) => !prev);
  };

  const [patientDrop, setpatientDrop] = useState(false);

  const togglepatientDropdown = () => {
    setpatientDrop((prev) => !prev);
  };
  const [staffDrop, setstaffDrop] = useState(false);

  const toggleStaffDropdown = () => {
    setstaffDrop((prev) => !prev);
  };
  const [calenderDrop, setcalenderDrop] = useState(false);

  const togglecalenderDropdown = () => {
    setcalenderDrop((prev) => !prev);
  };

  console.log(selector.dashboard);

  useEffect(() => {
    getBusinessProfile(dispatch);

    getBusinessDashboard(dispatch);
    getActivityLogs(dispatch, selectorAuth?.user?.business_id);
  }, [selectorAuth?.user?.business_id]);

  const refreshAppointment = async () => {
    getBusinessAppointment(
      dispatch,
      selectorAuth?.user?.business_id,
      dateselected
    );
  };

  console.log(selector.activityLogs);
  const [expandedComp, setexpandedComp] = useState("none");

  const data = [
    {
      type: "Pending",
      value: selector?.dashboard?.pending || 0,
    },
    {
      type: "Rescheduled",
      value: selector?.dashboard?.rescheduled || 0,
    },
    {
      type: "Cancelled",
      value: selector?.dashboard?.cancelled || 0,
    },
    {
      type: "Completed",
      value: selector?.dashboard?.completed || 0,
    },
  ];

  const dataAdmin = [
    {
      type: "Free",
      value: selector?.dashboard?.pending || 0,
    },
    {
      type: "Basic",
      value: selector?.dashboard?.rescheduled || 0,
    },
    {
      type: "Pro",
      value: selector?.dashboard?.cancelled || 0,
    },
    {
      type: "Premium",
      value: selector?.dashboard?.completed || 0,
    },
  ];
  const config = {
    appendPadding: 10,
    data: data,
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.6,
    label: {
      type: "inner",
      offset: "-50%",
      content: "{value}",
      style: {
        textAlign: "center",
        opacity: 0,
      },
    },
    interactions: [
      {
        type: "pie-legend-active",
      },
      {
        type: "element-active",
      },
    ],
  };
  const configAdmin = {
    appendPadding: 10,
    data: dataAdmin,
    // content:'',
    angleField: "value",
    colorField: "type",
    radius: 1,
    innerRadius: 0.6,
    label: {
      type: "inner",
      offset: "-50%",
      content: "{value}",
      style: {
        textAlign: "center",
        opacity: 0,
      },
    },
    // interactions: [
    //   {
    //     type: "pie-legend-active",
    //   },
    //   {
    //     type: "element-active",
    //   },
    // ],
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showAccount, setShowAccount] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [activePage, setActivePage] = useState(1);
  const itemsPerPage = 10;
  const startIndex = (activePage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const [selectedDate21, setSelectedDate21] = useState(null);

  const handleDateChange21 = (date) => {
    setSelectedDate21(date);
    console.log(date);
  };

  useEffect(() => {}, [selectedDate21]);
  const totalActivityLogs = selector.activityLogs?.length || 0;

  const handlePageChange = (event, newPage) => {
    setActivePage(newPage);
  };

  const nav = useNavigate();

  const isLoading =
    selector.loadingDashboard ||
    !selector.dashboard ||
    Object.keys(selector.dashboard).length === 0;

  // Skeleton placeholder component
  const DashboardSkeleton = () => (
    <div className="flex flex-col gap-2 w-full items-center relative overflow-x-hidden">
      {/* Greeting Skeleton */}
      <div className="w-full mb-1 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div className="h-10 w-64 bg-gray-200 rounded-lg animate-pulse"></div>
        <div className="h-6 w-48 bg-gray-200 rounded-lg animate-pulse"></div>
      </div>

      {/* Cards Skeleton */}
      <div className="flex flex-wrap w-full gap-3 items-stretch">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex-1 min-w-[50%] lg:min-w-[22%]">
            <div className="bg-white/80 backdrop-blur-xl items-center p-6 rounded-2xl flex gap-4 shadow-lg border border-white/20 h-full">
              <div className="w-14 h-14 bg-gray-200 rounded-xl animate-pulse"></div>
              <div className="flex-1 flex flex-col gap-2">
                <div className="h-6 w-32 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-4 w-24 bg-gray-200 rounded animate-pulse"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Stats Skeleton */}
      <div className="w-full flex flex-wrap gap-2">
        {[1, 2].map((i) => (
          <div
            key={i}
            className="flex-1 min-w-full lg:min-w-[48%] bg-white/80 backdrop-blur-xl rounded-xl p-4 shadow-xl border border-white/20"
          >
            <div className="h-6 w-48 bg-gray-200 rounded mb-4 animate-pulse"></div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
              {[1, 2, 3, 4].map((j) => (
                <div
                  key={j}
                  className="h-20 bg-gray-200 rounded-lg animate-pulse"
                ></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <AppLayout>
      {calenderDrop ? (
        <CalenderPopup
          closePopup={togglecalenderDropdown}
          openAppointment={toggleappointmentDropdown}
        />
      ) : (
        <></>
      )}
      {showAccount ? <AccountPopup closePopup={setShowAccount} /> : <></>}
      {shareDrop ? <SharePopup closePopup={toggleshareDropdown} /> : <></>}
      {serviceDrop ? (
        <ServicePopup closePopup={toggleserviceDropdown} />
      ) : (
        <></>
      )}

      {staffDrop ? (
        // <ServicePopup closePopup={toggleserviceDropdown}/>
        <StaffPopup closePopup={toggleStaffDropdown} />
      ) : (
        <></>
      )}
      {appointmentDrop ? (
        // <ServicePopup closePopup={toggleserviceDropdown}/>
        <AppointmentPopup closePopup={toggleappointmentDropdown} />
      ) : (
        <></>
      )}
      {patientDrop ? (
        // <ServicePopup closePopup={toggleserviceDropdown}/>
        <PatientPopup closePopup={togglepatientDropdown} />
      ) : (
        <></>
      )}
      {selectorAuth?.user?.role === "super_admin" ? (
        <div className="w-full overflow-y-auto overflow-x-hidden h-full flex flex-col items-start gap-4 px-4 pb-0">
          <Header
            title={"Admin Dashboard"}
            actions={
              <>
                <Button
                  variant="outlined"
                  startIcon={<MdExitToApp />}
                  size="small"
                  onClick={() => logOut(dispatch)}
                >
                  Logout
                </Button>
              </>
            }
          />
          <div className="flex flex-col gap-2 w-full items-center">
            <h1 className="font-semibold text-2xl">
              {new Date().getHours() < 12
                ? "Good morning"
                : new Date().getHours() < 18
                ? "Good afternoon"
                : "Good evening"}
              , {selectorAuth.user?.name}
            </h1>
            <p className="w-full text-center">
              Here's the summary of entire business flow
            </p>
          </div>
          <div className="flex flex-wrap w-full gap-4 items-center px-4 lg:px-10">
            {tenant?.modules?.appointments?.enabled && (
              <DashboardCard
                title={`${formatNumber(
                  selector.dashboard?.totalAppointments || 0,
                  0
                )} ${
                  selector.dashboard?.totalAppointments > 1
                    ? labels.appointments
                    : labels.appointment
                }`}
                color={"#0B469D"}
                desc={"Total for the day"}
                icon={<MdCalendarToday />}
                onClick={toggleappointmentDropdown}
                addButtonLink="/admin/appointment?add=true"
                isNotIcon={true}
              />
            )}
            {tenant?.modules?.customers?.enabled && (
              <DashboardCard
                isNotIcon={true}
                title={`${formatNumber(
                  selector.dashboard?.totalPatient || 0,
                  0
                )} ${labels.customers}`}
                desc={"Total since registration"}
                color={"#219104"}
                icon={<MdPerson />}
                onClick={togglepatientDropdown}
                addButtonLink="/admin/patient?add=true"
              />
            )}
            {tenant?.modules?.services?.enabled && (
              <DashboardCard
                isNotIcon={true}
                title={`${formatNumber(
                  selector.dashboard?.totalService || 0,
                  0
                )} ${labels.services}`}
                desc={"Total since registration"}
                color={"#ff0000"}
                icon={<MdSettings />}
                onClick={toggleserviceDropdown}
              />
            )}
            {tenant?.modules?.billing?.enabled && (
              <DashboardCard
                isNotIcon={true}
                title={`${formatNumber(
                  selector.dashboard?.revenue || 0,
                  0
                )} Revenue`}
                desc={"Total since registration"}
                color={"#ff6b00"}
                icon={<MdAttachMoney />}
                onClick={() => nav('/admin/billing')}
              />
            )}
          </div>
          <div
            className={`flex flex-wrap w-full ${
              expandedComp === "none" ? "gap-4" : "gap-0"
            } items-center px-4 lg:px-10`}
          >
            {
              // expandedComp === 'activity'?
              // <></>
              // :
              <div
                className={`bg-white transition-all relative rounded-md w-full ${
                  expandedComp !== "activity" ? "lg:w-[45%] flex-1" : "lg:w-0"
                } flex flex-col gap-4 ${
                  expandedComp !== "activity" ? "p-10" : "p-0"
                }`}
              >
                {expandedComp === "activity" ? (
                  <></>
                ) : (
                  <>
                    <div className="flex items-center gap-4">
                      <h2 className="text-xl font-semibold">
                        Subscription Summary
                      </h2>
                      <IoExpandOutline
                        className="cursor-pointer hidden lg:inline-block"
                        onClick={() => {
                          setexpandedComp((prev) =>
                            prev === "pie" ? "none" : "pie"
                          );
                        }}
                      />
                    </div>
                    <Pie {...configAdmin} />
                  </>
                )}
              </div>
            }
          </div>
        </div>
      ) : (
        <div className="w-full overflow-y-auto overflow-x-hidden h-full flex flex-col items-start gap-4 px-2 lg:px-4 custom-scrollbar">
          {/* Simple Header - Not a Card */}
          <div className="w-full flex items-center justify-between py-2">
            <h2 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
              Dashboard
            </h2>
            <div className="flex items-center gap-2">
              <IconButton
                onClick={toggleshareDropdown}
                size="small"
                sx={{ color: "#666" }}
              >
                <MdShare size={"1.25rem"} />
              </IconButton>
              <IconButton
                onClick={togglecalenderDropdown}
                size="small"
                sx={{ color: "#666" }}
              >
                <MdCalendarMonth size={"1.25rem"} />
              </IconButton>
              <IconButton onClick={handleClick} size="small">
                <Avatar
                  sx={{
                    color: "white",
                    bgcolor: "#0B469D",
                    textTransform: "uppercase",
                    width: 32,
                    height: 32,
                  }}
                >
                  {selectorAuth?.user?.name?.split("")[0]}
                </Avatar>
              </IconButton>
            </div>
          </div>

          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              onClick={() =>
                nav("/admin/profile/" + selectorAuth?.user?.business_id)
              }
            >
              <Avatar /> Profile
            </MenuItem>
            <Divider />
            <MenuItem
              onClick={() => {
                setShowAccount(true);
              }}
            >
              <ListItemIcon>
                <MdPeople />
              </ListItemIcon>
              Accounts
            </MenuItem>
            <MenuItem
              onClick={() => {
                deleteAccount(dispatch, selectorAuth?.user?.business_id);
              }}
            >
              <ListItemIcon>
                <MdDelete fontSize="small" />
              </ListItemIcon>
              Delete
            </MenuItem>
            <MenuItem
              onClick={() => {
                logOut(dispatch);
              }}
            >
              <ListItemIcon>
                <MdLogout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>

          {isLoading ? (
            <DashboardSkeleton />
          ) : selector.dashboard?.totalService <= 0 ||
            selector.dashboard?.totalStaff <= 0 ? (
            <div className="flex items-center justify-center w-full h-full !m-0 overflow-x-hidden">
              <div className="w-full max-w-4xl h-auto bg-form shadow-2xl rounded-lg p-6 lg:p-10 flex flex-col items-start gap-4 overflow-x-hidden">
                <h1 className="font-bold text-2xl">Complete your setup</h1>
                <p>Let&apos;s finish your setup to provide training</p>
                <div className="flex flex-col items-start pt-4">
                  <Setupcard
                    count={1}
                    disabled={false}
                    isCompleted={true}
                    onClick={() => {}}
                    btnText={""}
                    // isCompleted={true}
                    title="Business Setup"
                    description="Your profile has been setup for business"
                    route="/departments"
                  />
                  <span
                    className={`h-10 ml-8 w-1 ${
                      false ? "bg-gray-500" : "bg-primary"
                    } rounded-full`}
                  ></span>
                  <Setupcard
                    count={2}
                    disabled={false}
                    onClick={toggleserviceDropdown}
                    btnText={`Add ${labels.service || "Service"}`}
                    isCompleted={selector.dashboard?.totalService > 0}
                    title={labels.services || "Services"}
                    description="Add services with charges"
                    route="/trainees/create"
                  />
                  <span
                    className={`h-10 ml-8 w-1 ${
                      selector.dashboard?.totalService <= 0
                        ? "bg-gray-500"
                        : "bg-primary"
                    } rounded-full`}
                  ></span>
                  <Setupcard
                    count={3}
                    disabled={selector.dashboard?.totalService <= 0}
                    isCompleted={selector.dashboard?.totalStaff > 0}
                    title={labels.staff_plural || "Staff"}
                    onClick={toggleStaffDropdown}
                    btnText={`Add ${labels.staff || "Staff"}`}
                    description="Add staff details to generate your QR code"
                    route="/create-module"
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="flex flex-col gap-2 w-full items-center relative overflow-x-hidden px-4 my-2"
              >
                {/* Greeting Message and Business Name */}
                <div className="w-full mb-1 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                  <h1 className="font-bold text-2xl md:text-3xl bg-gradient-to-r from-purple-600 via-pink-500 to-blue-600 bg-clip-text text-transparent">
                    {new Date().getHours() < 12
                      ? "Good Morning"
                      : new Date().getHours() < 18
                      ? "Good Afternoon"
                      : "Good Evening"}{" "}
                    {selector.details?.owner || selectorAuth?.user?.name}
                    <span className="ml-2 text-2xl">
                      {new Date().getHours() < 12
                        ? "☕️"
                        : new Date().getHours() < 18
                        ? "☀️"
                        : "🌔"}
                    </span>
                  </h1>
                  <div className="text-right">
                    <p className="text-sm text-gray-600 font-medium">
                      <span className="font-semibold text-gray-800">
                        {selector?.business?.name}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="flex flex-wrap w-full gap-3 items-stretch">
                  <DashboardCard
                    title={
                      <Link to={"/admin/appointment"}>
                        {`${formatNumber(
                          selector.dashboard?.totalAppointments || 0,
                          0
                        )} ${
                          selector.dashboard?.totalAppointments > 1
                            ? labels.appointments || "Appointments"
                            : labels.appointment || "Appointment"
                        }`}
                      </Link>
                    }
                    color={"#0B469D"}
                    desc={"Total for the day"}
                    icon={<MdCalendarToday />}
                    onClick={toggleappointmentDropdown}
                    addButtonLink="/admin/appointment?add=true"
                  />
                  <DashboardCard
                    title={
                      <Link to={"/admin/patient"}>
                        {`${formatNumber(
                          selector.dashboard?.totalPatient || 0,
                          0
                        )} ${
                          selector.dashboard?.totalPatient > 1
                            ? labels.customers || "Customers"
                            : labels.customer || "Customer"
                        }`}
                      </Link>
                    }
                    desc={"Total since registration"}
                    color={"#219104"}
                    icon={<MdPerson />}
                    onClick={togglepatientDropdown}
                    addButtonLink="/admin/patient?add=true"
                  />
                  <DashboardCard
                    title={
                      <Link to={"/admin/service"}>
                        {`${formatNumber(
                          selector.dashboard?.totalService || 0,
                          0
                        )} ${
                          selector.dashboard?.totalService > 1
                            ? labels.services || "Services"
                            : labels.service || "Service"
                        }`}
                      </Link>
                    }
                    desc={"Total since registration"}
                    color={"#ff0000"}
                    icon={<MdSettings />}
                    onClick={toggleserviceDropdown}
                  />
                  <DashboardCard
                    color={"#4b0491"}
                    title={
                      <Link to={"/admin/staff"}>
                        {`${formatNumber(
                          selector.dashboard?.totalStaff || 0,
                          0
                        )} ${labels.staff_plural || "Staff"}`}
                      </Link>
                    }
                    desc={"Total since registration"}
                    icon={<MdPeople />}
                    onClick={toggleStaffDropdown}
                  />
                </div>

                {/* Detailed Stats Section */}
                <div className="w-full flex flex-wrap gap-2">
                  {/* Appointment Status Breakdown */}
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3, duration: 0.4 }}
                    className="flex-1 min-w-full lg:min-w-[48%] bg-white/80 backdrop-blur-xl rounded-xl p-4 shadow-xl border border-white/20"
                  >
                    <h3 className="text-base font-bold text-gray-800 mb-1.5">
                      Today's {labels.appointments || "Appointments"} Status
                    </h3>
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
                      <StatusCard
                        label="Pending"
                        value={selector.dashboard?.pending || 0}
                        color="#ff9800"
                        icon={<MdSchedule />}
                        total={selector.dashboard?.totalAppointments || 0}
                      />
                      <StatusCard
                        label="Completed"
                        value={selector.dashboard?.completed || 0}
                        color="#4caf50"
                        icon={<MdCheckCircle />}
                        total={selector.dashboard?.totalAppointments || 0}
                      />
                      <StatusCard
                        label="Rescheduled"
                        value={selector.dashboard?.rescheduled || 0}
                        color="#2196f3"
                        icon={<MdAccessTime />}
                        total={selector.dashboard?.totalAppointments || 0}
                      />
                      <StatusCard
                        label="Cancelled"
                        value={selector.dashboard?.cancelled || 0}
                        color="#f44336"
                        icon={<MdCancel />}
                        total={selector.dashboard?.totalAppointments || 0}
                      />
                    </div>
                  </motion.div>

                  {/* Performance Summary */}
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.35, duration: 0.4 }}
                    className="flex-1 min-w-full lg:min-w-[48%] bg-white/80 backdrop-blur-xl rounded-xl p-4 shadow-xl border border-white/20"
                  >
                    <h3 className="text-base font-bold text-gray-800 mb-1.5">
                      Performance Summary
                    </h3>
                    <div className="space-y-2">
                      <PerformanceMetric
                        label="Completion Rate"
                        value={
                          selector.dashboard?.performance?.completionRate ||
                          (selector.dashboard?.totalAppointments > 0
                            ? Math.round(
                                ((selector.dashboard?.completed || 0) /
                                  selector.dashboard?.totalAppointments) *
                                  100
                              )
                            : 0)
                        }
                        suffix="%"
                        color="#4caf50"
                        trend={
                          selector.dashboard?.trends?.appointmentsToday >
                          selector.dashboard?.trends?.appointmentsYesterday
                            ? "+"
                            : selector.dashboard?.trends?.appointmentsToday <
                              selector.dashboard?.trends?.appointmentsYesterday
                            ? "-"
                            : ""
                        }
                      />
                      <PerformanceMetric
                        label="Cancellation Rate"
                        value={
                          selector.dashboard?.performance?.cancellationRate ||
                          (selector.dashboard?.totalAppointments > 0
                            ? Math.round(
                                ((selector.dashboard?.cancelled || 0) /
                                  selector.dashboard?.totalAppointments) *
                                  100
                              )
                            : 0)
                        }
                        suffix="%"
                        color="#f44336"
                        trend={
                          selector.dashboard?.trends?.appointmentsToday <
                          selector.dashboard?.trends?.appointmentsYesterday
                            ? "-"
                            : ""
                        }
                      />
                      <PerformanceMetric
                        label="Average per Day"
                        value={
                          selector.dashboard?.performance
                            ?.averageAppointmentsPerDay ||
                          selector.dashboard?.totalAppointments ||
                          0
                        }
                        suffix={` ${labels.appointments?.toLowerCase() || "appointments"}`}
                        color="#2196f3"
                      />
                    </div>
                  </motion.div>
                </div>

                {/* Revenue & Trends Section */}
                {selector.dashboard?.revenue && (
                  <div className="w-full flex flex-wrap gap-2">
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.4, duration: 0.4 }}
                      className="flex-1 min-w-full lg:min-w-[48%] bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 shadow-xl border border-green-100"
                    >
                      <h3 className="text-base font-bold text-gray-800 mb-1.5 flex items-center gap-2">
                        <MdAttachMoney className="text-green-600 text-lg" />
                        Revenue Overview
                      </h3>
                      <div className="grid grid-cols-2 gap-2">
                        <div className="bg-white/80 rounded-lg p-3">
                          <p className="text-xs text-gray-600 mb-0.5">Today</p>
                          <p className="text-xl font-bold text-green-600">
                            ₹
                            {selector.dashboard.revenue.today?.toLocaleString(
                              "en-IN"
                            ) || 0}
                          </p>
                        </div>
                        <div className="bg-white/80 rounded-lg p-3">
                          <p className="text-xs text-gray-600 mb-0.5">
                            This Week
                          </p>
                          <p className="text-xl font-bold text-green-600">
                            ₹
                            {selector.dashboard.revenue.thisWeek?.toLocaleString(
                              "en-IN"
                            ) || 0}
                          </p>
                        </div>
                        <div className="bg-white/80 rounded-lg p-3">
                          <p className="text-xs text-gray-600 mb-0.5">
                            This Month
                          </p>
                          <p className="text-xl font-bold text-green-600">
                            ₹
                            {selector.dashboard.revenue.thisMonth?.toLocaleString(
                              "en-IN"
                            ) || 0}
                          </p>
                        </div>
                        <div className="bg-white/80 rounded-lg p-3">
                          <p className="text-xs text-gray-600 mb-0.5">Total</p>
                          <p className="text-xl font-bold text-green-600">
                            ₹
                            {selector.dashboard.revenue.total?.toLocaleString(
                              "en-IN"
                            ) || 0}
                          </p>
                        </div>
                      </div>
                    </motion.div>

                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: 0.45, duration: 0.4 }}
                      className="flex-1 min-w-full lg:min-w-[48%] bg-white/80 backdrop-blur-xl rounded-xl p-4 shadow-xl border border-white/20"
                    >
                      <h3 className="text-base font-bold text-gray-800 mb-1.5">
                        Quick Insights
                      </h3>
                      <div className="space-y-2">
                        <div className="flex items-center justify-between p-2 bg-blue-50 rounded-lg">
                          <span className="text-xs font-medium text-gray-700">
                            Upcoming Appointments
                          </span>
                          <span className="text-base font-bold text-blue-600">
                            {selector.dashboard.upcomingAppointments || 0}
                          </span>
                        </div>
                        <div className="flex items-center justify-between p-2 bg-purple-50 rounded-lg">
                          <span className="text-xs font-medium text-gray-700">
                            New {labels.customers || "Patients"} (7 days)
                          </span>
                          <span className="text-base font-bold text-purple-600">
                            {selector.dashboard.recentPatients || 0}
                          </span>
                        </div>
                        {selector.dashboard.trends && (
                          <>
                            <div className="flex items-center justify-between p-2 bg-green-50 rounded-lg">
                              <span className="text-xs font-medium text-gray-700">
                                Appointments Trend
                              </span>
                              <span
                                className={`text-xs font-semibold flex items-center gap-1 ${
                                  selector.dashboard.trends.appointmentsToday >=
                                  selector.dashboard.trends
                                    .appointmentsYesterday
                                    ? "text-green-600"
                                    : "text-red-600"
                                }`}
                              >
                                {selector.dashboard.trends.appointmentsToday >=
                                selector.dashboard.trends
                                  .appointmentsYesterday ? (
                                  <MdTrendingUp />
                                ) : (
                                  <MdTrendingDown />
                                )}
                                {selector.dashboard.trends.appointmentsToday >=
                                selector.dashboard.trends.appointmentsYesterday
                                  ? "+"
                                  : ""}
                                {selector.dashboard.trends.appointmentsToday -
                                  selector.dashboard.trends
                                    .appointmentsYesterday}
                              </span>
                            </div>
                            <div className="flex items-center justify-between p-2 bg-orange-50 rounded-lg">
                              <span className="text-xs font-medium text-gray-700">
                                Revenue Trend
                              </span>
                              <span
                                className={`text-xs font-semibold flex items-center gap-1 ${
                                  selector.dashboard.trends.revenueToday >=
                                  selector.dashboard.trends.revenueYesterday
                                    ? "text-green-600"
                                    : "text-red-600"
                                }`}
                              >
                                {selector.dashboard.trends.revenueToday >=
                                selector.dashboard.trends.revenueYesterday ? (
                                  <MdTrendingUp />
                                ) : (
                                  <MdTrendingDown />
                                )}
                                ₹
                                {Math.abs(
                                  selector.dashboard.trends.revenueToday -
                                    selector.dashboard.trends.revenueYesterday
                                ).toLocaleString("en-IN")}
                              </span>
                            </div>
                          </>
                        )}
                      </div>
                    </motion.div>
                  </div>
                )}

                <div
                  className={`flex flex-wrap w-full ${
                    expandedComp === "none" ? "gap-2" : "gap-0"
                  } items-center`}
                >
                  {
                    // expandedComp === 'activity'?
                    // <></>
                    // :

                    <motion.div
                      initial={{ opacity: 0, scale: 0.95 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: 0.4, duration: 0.4 }}
                      className={`bg-white/80 backdrop-blur-xl transition-all relative rounded-xl w-full h-auto lg:h-[520px] ${
                        expandedComp !== "activity"
                          ? "lg:w-[48%] flex-1"
                          : "lg:w-0"
                      } flex flex-col gap-2 overflow-hidden ${
                        expandedComp !== "activity"
                          ? "p-4 shadow-xl border border-white/20"
                          : "p-0"
                      }`}
                    >
                      {expandedComp === "activity" ? (
                        <></>
                      ) : (
                        <>
                          <div className="flex items-center justify-between mb-1.5">
                            <div>
                              <h2 className="text-lg font-bold text-gray-800">
                                Appointments Overview
                              </h2>
                              <p className="text-xs text-gray-600 mt-0.5">
                                Status breakdown for today (
                                {moment().format("DD MMM YYYY")})
                              </p>
                            </div>
                            <motion.div
                              whileHover={{ scale: 1.1, rotate: 180 }}
                              whileTap={{ scale: 0.9 }}
                            >
                              <IoExpandOutline
                                className="cursor-pointer hidden lg:inline-block text-gray-500 hover:text-gray-700 text-xl transition-colors"
                                onClick={() => {
                                  setexpandedComp((prev) =>
                                    prev === "pie" ? "none" : "pie"
                                  );
                                }}
                              />
                            </motion.div>
                          </div>
                          <div className="flex-1 flex flex-col items-center justify-start overflow-auto min-h-0 py-1">
                            <div
                              className="w-full max-w-md mb-2 flex-shrink-0"
                              style={{ height: "300px", minHeight: "300px" }}
                            >
                              <Pie {...config} />
                            </div>
                            <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 w-full max-w-md flex-shrink-0 px-2">
                              {data.map((item, index) => {
                                const colors = {
                                  Pending: "#ff9800",
                                  Completed: "#4caf50",
                                  Rescheduled: "#2196f3",
                                  Cancelled: "#f44336",
                                };
                                return (
                                  <div
                                    key={index}
                                    className="flex items-center gap-1.5 p-2 rounded-lg bg-gradient-to-br from-white to-gray-50 border border-gray-100 hover:shadow-md transition-all"
                                  >
                                    <div
                                      className="w-2.5 h-2.5 rounded-full flex-shrink-0"
                                      style={{
                                        backgroundColor:
                                          colors[item.type] || "#667eea",
                                      }}
                                    />
                                    <div className="flex-1 min-w-0">
                                      <p className="text-xs text-gray-600 truncate font-medium">
                                        {item.type}
                                      </p>
                                      <p className="text-base font-bold text-gray-800">
                                        {item.value}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      )}
                    </motion.div>
                  }
                  {
                    // expandedComp === 'pie'?
                    // <></>
                    // :
                    <motion.div
                      initial={{ opacity: 0, scale: 0.95 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ delay: 0.5, duration: 0.4 }}
                      className={`bg-white/80 backdrop-blur-xl transition-all duration-300 rounded-xl flex-1 w-full h-auto lg:h-[520px] ${
                        expandedComp !== "pie" ? "lg:w-[48%]" : "lg:w-0"
                      } flex flex-col gap-2 ${
                        expandedComp === "pie"
                          ? "p-0"
                          : "p-4 shadow-xl border border-white/20"
                      }`}
                    >
                      {expandedComp === "pie" ? (
                        <></>
                      ) : (
                        <>
                          <div className="flex items-center justify-between mb-1.5">
                            <h2 className="text-lg font-bold text-gray-800">
                              Activity Logs
                            </h2>
                            <motion.div
                              whileHover={{ scale: 1.1, rotate: 180 }}
                              whileTap={{ scale: 0.9 }}
                            >
                              <IoExpandOutline
                                className="cursor-pointer hidden lg:inline-block text-gray-500 hover:text-gray-700 text-2xl transition-colors"
                                onClick={() => {
                                  setexpandedComp((prev) =>
                                    prev === "activity" ? "none" : "activity"
                                  );
                                }}
                              />
                            </motion.div>
                          </div>
                          <div className="h-auto lg:h-[90%] flex-1 overflow-hidden">
                            <div className="h-full overflow-y-auto lg:overflow-y-scroll flex flex-col gap-2 pr-2 custom-scrollbar">
                              {selector.activityLogs
                                ?.slice(startIndex, endIndex) // Display the subset of activity logs for the current page
                                .map((e, i) => (
                                  <ActivityCard
                                    key={i}
                                    title={e.activity_name}
                                    desc={e.activity_description}
                                    icon={getIconsByType(e.activity_type)}
                                    color={getColorsByType(e.activity_type)}
                                    time={moment(e.timestamp).fromNow()}
                                  />
                                ))}
                            </div>
                            <div className="flex justify-center flex-shrink-5 mt-4 sm:mt-[0.3rem]">
                              <Pagination
                                count={Math.ceil(
                                  totalActivityLogs / itemsPerPage
                                )}
                                page={activePage}
                                onChange={handlePageChange}
                                // shape="rounded"
                                size="small"
                                sx={{
                                  // '& .MuiPaginationItem-root': {
                                  //   color: '#0B469D',
                                  // },
                                  "& .Mui-selected": {
                                    backgroundColor: "#0B469D",
                                    color: "#fff",
                                    "&:hover": {
                                      backgroundColor: "#72a9fb",
                                    },
                                  },

                                  // '@media (max-width: 640px)': {
                                  //   '& .MuiPaginationItem-root': {
                                  //     fontSize: '14px',
                                  //     size:"small",
                                  //     gap:'1px',
                                  //   },

                                  // },
                                }}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </motion.div>
                  }
                </div>
              </motion.div>
            </>
          )}
        </div>
      )}
    </AppLayout>
  );
};

const ActivityCard = ({ color, icon, title, desc, time }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3 }}
      className="w-full flex items-start gap-4 p-4 rounded-xl hover:bg-white/50 transition-all duration-300"
    >
      <motion.div
        whileHover={{ scale: 1.1, rotate: 5 }}
        style={{
          backgroundColor: color + "15",
          color: color,
        }}
        className="w-12 h-12 rounded-xl flex justify-center items-center text-xl flex-shrink-0 shadow-sm"
      >
        {icon}
      </motion.div>
      <div className="flex-1 flex flex-col items-start min-w-0">
        <h4 className="text-base font-semibold text-gray-800 mb-1">{title}</h4>
        <p className="text-sm text-gray-600 mb-2 line-clamp-2">{desc}</p>
        <p
          style={{ color }}
          className="text-xs font-medium flex items-center gap-1"
        >
          <span
            className="w-1.5 h-1.5 rounded-full"
            style={{ backgroundColor: color }}
          ></span>
          {time}
        </p>
      </div>
    </motion.div>
  );
};

const StatusCard = ({ label, value, color, icon, total }) => {
  const percentage = total > 0 ? Math.round((value / total) * 100) : 0;
  return (
    <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-2 border border-gray-100 hover:shadow-md transition-all">
      <div className="flex items-center justify-between mb-1">
        <div
          style={{ backgroundColor: color + "15", color }}
          className="w-8 h-8 rounded-lg flex items-center justify-center text-base"
        >
          {icon}
        </div>
        <span className="text-xs font-semibold text-gray-500">
          {percentage}%
        </span>
      </div>
      <div className="text-xl font-bold" style={{ color }}>
        {value}
      </div>
      <div className="text-xs text-gray-600 font-medium mt-0.5">{label}</div>
      <div className="mt-1.5 h-1 bg-gray-200 rounded-full overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.8, delay: 0.2 }}
          style={{ backgroundColor: color }}
          className="h-full rounded-full"
        />
      </div>
    </div>
  );
};

const PerformanceMetric = ({ label, value, suffix, color, trend }) => {
  return (
    <div className="flex items-center justify-between p-2 bg-gradient-to-r from-white to-gray-50 rounded-lg border border-gray-100">
      <div className="flex-1">
        <p className="text-xs text-gray-600 font-medium mb-0.5">{label}</p>
        <div className="flex items-baseline gap-1.5">
          <span className="text-lg font-bold" style={{ color }}>
            {value}
          </span>
          <span className="text-xs text-gray-500">{suffix}</span>
          {trend && (
            <span
              className={`text-xs font-semibold flex items-center gap-1 ${
                trend.startsWith("+") ? "text-green-600" : "text-red-600"
              }`}
            >
              {trend.startsWith("+") ? <MdTrendingUp /> : <MdTrendingDown />}
              {trend}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

const DashboardCard = ({
  title,
  icon,
  desc,
  color,
  onClick,
  isNotIcon,
  addButtonLink,
}) => {
  const handleAddClick = (e) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  const handleCardClick = (e) => {
    // Only navigate if not clicking on the add button
    if (!e.target.closest(".add-button")) {
      // Extract the link from title if it's a Link component
      const linkElement = title?.props?.to;
      if (linkElement) {
        window.location.href = linkElement;
      }
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -5, scale: 1.02 }}
      transition={{ duration: 0.3 }}
      className="flex-1 min-w-[50%] lg:min-w-[22%] cursor-pointer relative"
      onClick={handleCardClick}
    >
      <div className="bg-white/80 backdrop-blur-xl items-center p-6 rounded-2xl flex gap-4 shadow-lg border border-white/20 hover:shadow-xl transition-all duration-300 h-full">
        <motion.div
          whileHover={{ rotate: 10, scale: 1.1 }}
          transition={{ type: "spring", stiffness: 300 }}
          style={{
            backgroundColor: color + "15",
            color: color,
          }}
          className="w-14 h-14 rounded-xl flex justify-center items-center text-2xl flex-shrink-0"
        >
          {icon}
        </motion.div>
        <div className="flex-1 flex flex-col items-start min-w-0">
          <h4
            style={{ color }}
            className="text-xl font-bold mb-1 truncate w-full"
          >
            {title}
          </h4>
          {desc && <p className="text-sm text-gray-600 font-medium">{desc}</p>}
        </div>
        {!isNotIcon && (
          <motion.div
            whileHover={{ rotate: 90, scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="flex-shrink-0 add-button"
            onClick={handleAddClick}
          >
            <MdAdd className="text-gray-400 hover:text-gray-600 text-2xl transition-colors" />
          </motion.div>
        )}
        {isNotIcon && (
          <motion.div
            whileHover={{ rotate: 90, scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            className="flex-shrink-0 add-button"
            onClick={handleAddClick}
          >
            <MdAdd
              className={`text-gray-400 hover:text-gray-600 text-2xl transition-colors cursor-pointer`}
            />
          </motion.div>
        )}
      </div>
    </motion.div>
  );
};

export const CalenderPopup = ({ closePopup, openAppointment }) => {
  const dispatch = useDispatch();
  const dateState = useSelector((state) => state.date);
  const authState = useSelector((state) => state.auth);
  const businessState = useSelector((state) => state.business);
  useEffect(() => {
    setInitialDate(dispatch);
    setInitialMobileDate(dispatch);
    getBusinessStaff(dispatch, authState?.user?.business_id);
    getBusinessAppointment(
      dispatch,
      authState?.user?.business_id,
      moment(dateState.selectedDate).format("yyyy-MM-DD")
    );
  }, [dateState.selectedDate]);
  return (
    <div className="w-full z-20 h-screen left-0 top-0 fixed bg-black/40 flex items-center justify-center overflow-y-auto p-4">
      <div className="w-full max-w-5xl min-h-[80%] max-h-[100%] lg:max-h-[95%] p-4 lg:p-10 bg-white rounded-lg relative flex items-center gap-4 lg:gap-10 flex-col overflow-x-hidden">
        <span
          onClick={closePopup}
          className="cursor-pointer absolute top-2 lg:top-4 right-2 lg:right-4"
        >
          <MdClose />
        </span>
        <div className="flex items-center gap-8 w-full justify-between mt-4">
          <div className="flex items-center gap-8 w-full">
            <label htmlFor="dateCalendar">
              <h2 className="font-bold text-xl">
                {
                  // moment(new Date().toISOString()).format('DD MMM, yyyy')
                  moment(dateState.selectedDate).format("DD MMM, yyyy")
                }
              </h2>
            </label>
            <input
              type="date"
              className="hidden"
              name="dateCalendar"
              id="dateCalendar"
            />
            <select
              className="flex-none w-40 hidden lg:inline-block"
              onChange={(e) => {
                if (Number(e.target.value) === 0) {
                  dispatch(resetAppointment());
                } else {
                  dispatch(filterAppointmentByStaff(Number(e.target.value)));
                }
              }}
            >
              <option value={0}>All Staff</option>
              {businessState.staff?.map((e, i) => (
                <option key={i} value={e.staff_id}>
                  {e.name}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={() => {
              openAppointment();
              // }} className="button text-xs w-[80%] lg:w-[40%] p-2 bg-primary text-white rounded-full lg:text-base" >Book Appointment</button>
            }}
            className="button text-xs w-[80%] lg:w-[40%] p-2  lg:text-base"
          >
            Book Appointment
          </button>
        </div>
        <select
          className="flex-none w-full lg:hidden inline-block"
          onChange={(e) => {
            if (Number(e.target.value) === 0) {
              dispatch(resetAppointment());
            } else {
              dispatch(filterAppointmentByStaff(Number(e.target.value)));
            }
          }}
        >
          <option value={0}>All Staff</option>
          {businessState.staff?.map((e, i) => (
            <option key={i} value={e.staff_id}>
              {e.name}
            </option>
          ))}
        </select>
        <div className="flex items-center gap-2 w-full">
          <IconButton
            onClick={() => removeDate(dispatch)}
            sx={{ bgcolor: "#ededed" }}
          >
            <MdArrowBackIos size={"1rem"} />
          </IconButton>
          <div className="flex-1">
            <div className="w-full flex items-center justify-evenly">
              {dateState.datesMobile.map((e, i) => (
                <div
                  onClick={() => dispatch(setSelectedDate(e))}
                  key={i}
                  className={`cursor-pointer flex lg:hidden flex-col gap-0 lg:gap-2 items-center px-3 py-2 rounded-full ${
                    compareDate(e, dateState.selectedDate)
                      ? "border-2 border-primary"
                      : ""
                  }`}
                >
                  <p
                    className={`text-xs ${
                      compareDate(e, dateState.selectedDate) ? "text-black" : ""
                    }`}
                  >
                    {returnMonth(e)}
                  </p>
                  <h4
                    className={`font-semibold text-xl ${
                      compareDate(e, dateState.selectedDate)
                        ? "text-primary"
                        : ""
                    }`}
                  >
                    {e?.getDate()}
                  </h4>
                  <p
                    className={`text-xs  ${
                      compareDate(e, dateState.selectedDate)
                        ? "text-gray-400"
                        : "text-gray-400"
                    }`}
                  >
                    {returnWeek(e)}
                  </p>
                </div>
              ))}
            </div>
            <div className="hidden w-full lg:flex items-center justify-evenly">
              {dateState.dates.map((e, i) => (
                <div
                  onClick={() => dispatch(setSelectedDate(e))}
                  key={i}
                  className={`cursor-pointer lg:flex hidden flex-col gap-0 lg:gap-2 items-center px-4 py-2 rounded-full ${
                    compareDate(e, dateState.selectedDate)
                      ? "border-2 border-primary"
                      : ""
                  }`}
                >
                  <p
                    className={`text-xs ${
                      compareDate(e, dateState.selectedDate) ? "text-black" : ""
                    }`}
                  >
                    {returnMonth(e)}
                  </p>
                  <h4
                    className={`font-semibold text-2xl ${
                      compareDate(e, dateState.selectedDate)
                        ? "text-primary"
                        : ""
                    }`}
                  >
                    {e?.getDate()}
                  </h4>
                  <p
                    className={`text-xs  ${
                      compareDate(e, dateState.selectedDate)
                        ? "text-gray-400"
                        : "text-gray-400"
                    } uppercase`}
                  >
                    {returnWeek(e)}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <IconButton
            onClick={() => addDate(dispatch)}
            sx={{ bgcolor: "#ededed" }}
          >
            <MdArrowForwardIos size={"1rem"} />
          </IconButton>
        </div>
        {/* <div className="w-full">
      <Divider variant="fullWidth"/>
      </div> */}
        <div className="flex flex-col items-center overflow-y-scroll w-full no-scrollbar">
          {timeLine().map((timeData, i) => (
            <div
              key={i}
              className="border border-gray-100 w-full flex h-[400px]"
            >
              <div className="w-[20%] h-full border-r border-r-gray-100 flex items-center justify-center">
                <h4 className="text-xs lg:text-base">{timeData.label}</h4>
              </div>
              <div className="w-[80%] h-full">
                {/* <h4>12:00 am</h4> */}
                <div className="w-full h-full flex items-center gap-4 overflow-x-auto overflow-y-hidden p-4 no-scrollbar">
                  {businessState.appointments?.map((el, inD) =>
                    compareTime(timeData.value, el.start_time) ? (
                      <div
                        style={{
                          backgroundColor: returnStaffColor[el.staff_color],
                        }}
                        className={`rounded p-2 w-auto whitespace-nowrap h-full flex flex-col gap-2 bg-[${
                          returnStaffColor[el.staff_color]
                        }]`}
                        key={inD}
                      >
                        <h4 className="font-semibold">
                          {el.patient_name} {el.staff_name}
                        </h4>
                        <p className="text-xs">
                          {moment(el.start_time, "HH:mm:ss").format("hh:mm A")}{" "}
                          to {moment(el.end_time, "HH:mm:ss").format("hh:mm A")}
                        </p>
                      </div>
                    ) : (
                      <></>
                    )
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export const SharePopup = ({ closePopup }) => {
  const [modalActive, setModalActive] = useState(false);

  const selector = useSelector((state) => state.business);
  const link = `https://taa.dukaani.in/business/${selector?.details?.name
    ?.trim()
    .replaceAll(" ", "_")}/${selector?.details?.business_id}/book-appointment`;

  const dispatch = useDispatch();

  const facebookIcon = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${link}`,
      "_blank"
    );
  };

  const instagramIcon = () => {
    window.open("https://www.instagram.com", "_blank");
  };

  const whatsappIcon = () => {
    window.open(
      `https://api.whatsapp.com/send?&text=${encodeURIComponent(link)}`,
      "_blank"
    );
  };

  const telegramIcon = () => {
    window.open(
      `https://t.me/share/url?url=${encodeURIComponent(link)}`,
      "_blank"
    );
  };

  const gmailIcon = () => {
    const emailBody = `Check out this link: ${link}`;
    const emailSubject = "Check Out This Link";
    // window.open(`https://mail.google.com/mail/u/0/#inbox?compose=new?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`, '_top');
    window.open("https://mail.google.com/mail?view=cm&tf=0&to=&su=", "_blank");
  };

  return (
    <div className="w-full z-20 h-screen left-0 top-0 fixed bg-black/40 flex items-center justify-center overflow-y-auto p-4">
      <div className="w-[90%] lg:w-[60%] min-h-[60%] p-10 bg-white rounded-lg relative flex items-center gap-10 flex-col">
        <span
          onClick={closePopup}
          className="cursor-pointer absolute top-4 right-4"
        >
          <MdClose />
        </span>
        <h2 className="font-bold text-2xl">QR Code</h2>
        <div className="w-full flex items-center flex-wrap-reverse gap-10">
          <div className="flex-1 min-w-full lg:min-w-[45%]">
            <h2 className="font-medium text-xl w-full text-center">
              Share your QR code <br /> for booking an Appointment
            </h2>
            <div className="flex items-center justify-center gap-10"></div>

            <div className="w-full flex items-center gap-2 my-2">
              <span className="flex-1 h-[1px] bg-gray-400"></span>
              <p>OR</p>
              <span className="flex-1 h-[1px] bg-gray-400"></span>
            </div>
            <div className="w-full flex items-center gap-4 justify-center">
              <div className="w-fit max-w-[70%] p-4 bg-gray-50 rounded-md">
                <a
                  className="text-ellipsis w-full overflow-hidden whitespace-nowrap block"
                  href={`https://taa.dukaani.in/business/${selector?.details?.name
                    ?.trim()
                    .replaceAll(" ", "_")}/${
                    selector?.details?.business_id
                  }/book-appointment`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {`https://taa.dukaani.in/business/${selector?.details?.name
                    ?.trim()
                    .replaceAll(" ", "_")}/${
                    selector?.details?.business_id
                  }/book-appointment`}
                </a>
              </div>
              {/* <RWebShare
                data={{
                  text: "Hello, Click this link for booking Appointment.",
                  url: `https://taa.dukaani.in/business/${selector?.details?.name
                    ?.trim()
                    .replaceAll(" ", "_")}/${
                    selector?.details?.business_id
                  }/book-appointment`,
                  title: "Share link",
                }}
                disableNative={false}
                onClick={() => console.log("shared successfully!")}
              > */}
              {/* <button>Share Link</button> */}
              {/* </RWebShare> */}
              <PopupCallButton setActive={setModalActive}>
                <MdShare />
              </PopupCallButton>
              {/* {isCopied ? (
        <img id="copy-btn"src={copy2} alt="Copying..." />
    ) : (
        <img src={copy2} alt="Not Copying..." />
    )} */}

              <Popup active={modalActive} setActive={setModalActive}>
                <div className="popup">
                  <header>
                    {/* <span>Share QR Code</span> */}
                    <span
                      className="absolute top-2 right-2 cursor-pointer"
                      onClick={() => setModalActive((prev) => !prev)}
                    >
                      <RxCross2 size={24} />
                    </span>
                  </header>
                  <div className="content">
                    <p className=" text-center font-sans font-semibold text-lg">
                      Share the booking link via
                    </p>
                    <ul className=" flex flex-row justify-evenly items-center gap-2 mt-8">
                      <div
                        onClick={facebookIcon}
                        className="icon-circle cursor-pointer text-blue-500 p-2 border  hover:text-white border-blue-500 rounded-[50%] hover:bg-blue-500"
                      >
                        <FaFacebookF className="icon" size={24} />
                      </div>
                      {/* <div className="icon-circle text-blue-500">
        <FaTwitter className="icon" />
      </div> */}
                      <div
                        onClick={instagramIcon}
                        className="icon-circle cursor-pointer text-pink-600 p-2 border  hover:text-white border-pink-600 rounded-[50%] hover:bg-pink-600"
                      >
                        <FaInstagram className="icon" size={24} />
                      </div>
                      <div
                        onClick={whatsappIcon}
                        className="icon-circle cursor-pointer text-green-500 p-2 border  hover:text-white border-green-500 rounded-[50%] hover:bg-green-500"
                      >
                        <FaWhatsapp className="icon" size={24} />
                      </div>
                      <div
                        onClick={telegramIcon}
                        className="icon-circle cursor-pointer text-blue-500 p-2 border  hover:text-white border-blue-500 rounded-[50%] hover:bg-blue-500"
                      >
                        <FaTelegramPlane className="icon" size={24} />
                      </div>
                      <div
                        onClick={gmailIcon}
                        className="icon-circle cursor-pointer text-red-500 p-2 border  hover:text-white border-red-500 rounded-[50%] hover:bg-red-500"
                      >
                        <FaEnvelope className="icon" size={24} />
                      </div>
                    </ul>
                    {/* <i className="url-icon uil uil-link"></i> */}
                    {/* <p>Or copy link</p>
        <div className="field">
            <input type="text" readOnly value = {url||SERVER_DOMAIN} />
            <button onClick={handleCopyClick}>
            <span>{isCopied ? 'Copied!' : 'Copy'}</span>
            </button>
        </div> */}
                  </div>
                </div>
              </Popup>

              <CopyToClipboard
                onCopy={() => successMessage(dispatch, "URL Copied")}
                text={`https://taa.dukaani.in/business/${selector?.details?.name
                  ?.trim()
                  .replaceAll(" ", "_")}/${
                  selector?.details?.business_id
                }/book-appointment`}
              >
                <MdCopyAll className="text-2xl cursor-pointer" />
              </CopyToClipboard>
            </div>
          </div>
          <div className="w-fit bg-primary rounded-lg p-10 flex items-center flex-col gap-4">
            <div className="w-fit rounded-md p-2 mx-auto bg-white">
              {/* <p>{selector?.details?.business_name?.replace('\d','_')}</p> */}
              <QRCode
                size={200}
                value={`https://taa.dukaani.in/business/${selector?.details?.name
                  ?.trim()
                  .replaceAll(" ", "_")}/${
                  selector?.details?.business_id
                }/book-appointment`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AppointmentPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.business);
  const labels = useLabels();
  useEffect(() => {
    if (selector.details?.business_id) {
      getBusinessPatients(dispatch, selector.details.business_id);
      getBusinessServices(dispatch, selector.details.business_id);
      getBusinessStaff(dispatch, selector.details.business_id);
    }
  }, [dispatch, selector.details?.business_id]);
  // const [filterContact, setFilterContact] = useState(" ");
  const [selectedContact, setSelectedContact] = useState("");
  const [selectedPatient, setSelectedPatient] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(""); // Keep for backward compatibility
  const [showPatientPopup, setShowPatientPopup] = useState("");

  const [appointment, setappointment] = useState({
    time: dayjs(new Date().toISOString()),
    date: dayjs(new Date().toISOString()),
    reason: "",
    duration: 15,
    staff: 0,
    customer: 0,
    service: "",
  });

  const nav = useNavigate();
  // const getCustomerContact = (customerId) => {
  //   const customer = selector.patients || selector.customers.find((c) => c.patient_id === customerId);
  //   return customer ? customer.contact : null;
  // };
  //   const handleKeyDown = (e) => {
  //     if (e.key === "ArrowDown") {
  //         // Move to the next result
  //         e.preventDefault(); // Prevents scrolling of the page
  //         const currentIndex = filteredPatients.findIndex((el) => el.patient_id === appointment.patient || appointment.customer);
  //         if (currentIndex < filteredPatients.length - 1) {
  //             const nextCustomer = filteredPatients[currentIndex + 1];
  //             setappointment((prev) => ({ ...prev, customer: nextCustomer.patient_id }));
  //             setSelectedCustomer(nextCustomer.full_name);
  //             setSelectedContact(nextCustomer.contact);
  //         }
  //     } else if (e.key === "ArrowUp") {
  //         // Move to the previous result
  //         e.preventDefault(); // Prevents scrolling of the page
  //         const currentIndex = filteredPatients.findIndex((el) => el.patient_id === appointment.patient || appointment.customer);
  //         if (currentIndex > 0) {
  //             const prevCustomer = filteredPatients[currentIndex - 1];
  //             setappointment((prev) => ({ ...prev, customer: prevCustomer.patient_id }));
  //             setSelectedCustomer(prevCustomer.full_name);
  //             setSelectedContact(prevCustomer.contact);
  //         }
  //     }
  // };
  const onSubmit = () => {
    console.log(appointment);
    getBusinessDetails(dispatch, selector.details.business_id);

    // const customerContact = getCustomerContact(appointment.patient || appointment.customer);
    console.log("Customer Contact:", selectedContact);
    console.log("Customer ID:", appointment.patient || appointment.customer);
    // Validate all required fields
    const patientId = appointment.patient || appointment.customer;
    const serviceId = appointment.service;
    const staffId = appointment.staff;

    if (
      patientId &&
      patientId !== 0 &&
      patientId !== "" &&
      serviceId &&
      serviceId !== 0 &&
      serviceId !== "" &&
      serviceId !== "0" &&
      staffId &&
      staffId !== "" &&
      staffId !== 0 &&
      appointment.date &&
      appointment.time
    ) {
      const end = appointment.time.add(appointment.duration, "minutes");
      const customerIdNum = Number(patientId);

      // Ensure customer_id is a valid number
      if (isNaN(customerIdNum) || customerIdNum === 0) {
        dispatch(
          failedBookAppointment({ message: "Please select a patient!" })
        );
        return;
      }

      const req = {
        start_time:
          (appointment.time.hour() < 10
            ? `0${appointment.time.hour()}`
            : appointment.time.hour()) +
          ":" +
          (appointment.time.minute() < 10
            ? `0${appointment.time.minute()}`
            : appointment.time.minute()) +
          ":00",
        end_time:
          (end.hour() < 10 ? `0${end.hour()}` : end.hour()) +
          ":" +
          (end.minute() < 10 ? `0${end.minute()}` : end.minute()) +
          ":00",
        start_date:
          appointment.date.year() +
          "-" +
          (appointment.date.month() + 1 < 10
            ? `0${appointment.date.month() + 1}`
            : appointment.date.month() + 1) +
          "-" +
          (appointment.date.date() < 10
            ? `0${appointment.date.date()}`
            : appointment.date.date()),
        end_date:
          appointment.date.year() +
          "-" +
          (appointment.date.month() + 1 < 10
            ? `0${appointment.date.month() + 1}`
            : appointment.date.month() + 1) +
          "-" +
          (appointment.date.date() < 10
            ? `0${appointment.date.date()}`
            : appointment.date.date()),
        reason: appointment.reason || "",
        staff_id: Number(staffId),
        customer_id: customerIdNum, // Required by validator
        patient_id: customerIdNum, // Also send patient_id for backward compatibility
        service_id: String(serviceId),
      };

      // Final validation - ensure customer_id is valid (required by validator)
      if (!req.customer_id || req.customer_id === 0 || isNaN(req.customer_id)) {
        dispatch(
          failedBookAppointment({ message: "Please select a patient!" })
        );
        return;
      }

      console.log("Sending appointment request:", {
        customer_id: req.customer_id,
        staff_id: req.staff_id,
        service_id: req.service_id,
      });
      const req2 = {
        contact: selectedContact,
        patient_name: selectedPatient || selectedPatient,
        name: selector.details.name,
        businessContact: selector.details.contact,
      };
      // console.log("Selected Customer Contact:", filteredPatients.map((el,i) => {console.log(el.contact)}));
      console.log(req, "vraj");
      addbusinessAppointment(
        dispatch,
        req2,

        req,
        () => {
          setappointment({
            time: dayjs(new Date().toISOString()),
            date: dayjs(new Date().toISOString()),
            reason: "",
            duration: 15,
            staff: 0,
            customer: 0,
            service: "",
          });
          closePopup();
        }
      );
      const message =
        "Hi " +
        selectedPatient +
        ",\nYour appointment is successfully booked on " +
        req.start_date +
        " at " +
        req.start_time +
        "\nThank You!\n\nTeam- " +
        selector.details.name +
        "\nContact- " +
        selector.details.contact +
        "\ntheappointmentapp.com";

      const whatsappUrl = `https://api.whatsapp.com/send?phone=${selectedContact}&text=${encodeURIComponent(
        message
      )}`;
      setTimeout(() => {
        window.open(whatsappUrl, "_blank");
      }, 900);
    } else {
      dispatch(failedBookAppointment({ message: "Please fill all details!" }));
    }
  };
  const [searchText, setSearchText] = useState("");
  const [ShowSearchBar, setShowSearchBar] = useState("");

  const filteredPatients =
    selector.patients ||
    selector.customers?.filter((el, i) =>
      el.full_name.toLowerCase().includes(searchText.toLowerCase())
    );
  // const filterContact = filteredPatients.map((el,i)=>{
  //   return el.contact
  // })

  // const [customersContact, setCustomersContact] = useState([]);

  //   useEffect(() => {
  //     // Fetch customers and set them in state
  //     getBusinessCustomers(dispatch,selector.details.business_id)
  //       .then((data) => setCustomersContact(data?.data))
  //       .catch((error) => console.log(error));
  //   },[dispatch,selector.details.business_id]);

  // console.log(customersContact);
  // const customerContact = getCustomerContact(appointment.patient || appointment.customer);

  // console.log(filterContact);
  // const handleCustomerChange = (ev) => {
  //   const selectedPatientId = ev.target.value;
  //   setappointment((prev) => ({ ...prev, customer: selectedPatientId }));

  //   const selectedPatient = filteredPatients.find(
  //     (el) => el.patient_id === selectedPatientId
  //   );

  //   if (selectedPatient) {
  //     setFilterContact(selectedPatient.contact);
  //   } else {
  //     setFilterContact(""); // Reset contact if customer not found
  //   }
  // };
  // console.log('Customer Contact:', CUSTOMERS);

  console.log(selector.services);
  return (
    <Dialog
      open={true}
      onClose={closePopup}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          background: "rgba(255, 255, 255, 0.98)",
          backdropFilter: "blur(20px)",
          maxHeight: "85vh",
          margin: "16px",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          fontWeight: 700,
          fontSize: { xs: "1.125rem", sm: "1.25rem" },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
          px: 2.5,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Book Appointment
        </Typography>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Button
            variant="outlined"
            startIcon={<MdPersonAdd />}
            onClick={() => setShowPatientPopup(true)}
            size="small"
            sx={{
              borderRadius: "8px",
              borderColor: "rgba(255, 255, 255, 0.5)",
              color: "white",
              fontWeight: 600,
              textTransform: "none",
              fontSize: "0.875rem",
              "&:hover": {
                borderColor: "white",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              },
            }}
          >
            Add {labels.customer || "Patient"}
          </Button>
          <IconButton
            onClick={closePopup}
            sx={{
              color: "white",
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
            }}
          >
            <MdClose size={24} />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          pt: 6,
          px: { xs: 2.5, sm: 3 },
          pb: { xs: 2.5, sm: 3 },
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
            mt: 1,
          }}
        >
          {showPatientPopup && (
            <PatientPopup closePopup={() => setShowPatientPopup(false)} />
          )}
          <Box sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}>
            <TextField
              select
              fullWidth
              label={`Select ${labels.customer || "Patient"}`}
              value={appointment.patient || appointment.customer || ""}
              onChange={(ev) => {
                const selectedValue = ev.target.value;
                setappointment((prev) => ({
                  ...prev,
                  customer: selectedValue,
                  patient: selectedValue,
                }));

                // Find the selected patient from the filtered list
                const selectedPatient = filteredPatients?.find(
                  (p) =>
                    p.patient_id === selectedValue ||
                    String(p.patient_id) === String(selectedValue)
                );

                if (selectedPatient) {
                  setSelectedContact(selectedPatient.contact || "");
                  setSelectedPatient(selectedPatient.full_name || "");
                  setSelectedCustomer(selectedPatient.full_name || "");
                } else {
                  setSelectedContact("");
                  setSelectedPatient("");
                  setSelectedCustomer("");
                }
              }}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                },
              }}
            >
              <MenuItem value="">Select {labels.customer?.toLowerCase() || "patient"}</MenuItem>
              {filteredPatients?.map((el, i) => (
                <MenuItem key={el.patient_id} value={el.patient_id}>
                  {el.full_name}
                </MenuItem>
              ))}
            </TextField>
            <IconButton
              onClick={() => setShowSearchBar((prev) => !prev)}
              sx={{
                backgroundColor: "rgba(102, 126, 234, 0.1)",
                "&:hover": { backgroundColor: "rgba(102, 126, 234, 0.2)" },
              }}
            >
              <MdSearch />
            </IconButton>
          </Box>
          {ShowSearchBar && (
            <Box
              sx={{
                position: "absolute",
                zIndex: 1300,
                width: "calc(100% - 64px)",
                maxWidth: "500px",
                mt: 8,
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
                border: "1px solid rgba(0,0,0,0.1)",
              }}
            >
              <TextField
                fullWidth
                placeholder="Search for patients..."
                value={searchText}
                onChange={(ev) => setSearchText(ev.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px 12px 0 0",
                  },
                }}
              />
              <Box
                sx={{
                  maxHeight: "200px",
                  overflowY: "auto",
                  "&::-webkit-scrollbar": { display: "none" },
                  scrollbarWidth: "none",
                }}
              >
                {filteredPatients?.map((el, i) => (
                  <Box
                    key={el.patient_id}
                    onClick={() => {
                      setappointment((prev) => ({
                        ...prev,
                        customer: el.patient_id,
                      }));
                      setSelectedCustomer(el.full_name);
                      setSelectedContact(el.contact);
                      setShowSearchBar(false);
                    }}
                    sx={{
                      p: 2,
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "rgba(102, 126, 234, 0.1)",
                      },
                    }}
                  >
                    {el.full_name}
                  </Box>
                ))}
              </Box>
            </Box>
          )}
          {/* <select
        name=""
        id=""
        placeholder={`Select ${labels.customer || "Patient"}`}
        value={appointment.contact}
        onChange={(ev) => {
          setappointment((prev) => ({ ...prev, customer: ev.target.value }));
        }}
      >
        <option value="">Select {labels.customer?.toLowerCase() || "patient"}</option>
        {filteredPatients.map((el, i) => (
          <option key={el.patient_id} value={el.patient_id}>
            {el.contact}
            
          </option>
        ))}
      </select> */}
          {/* <input
  type="text"
  value={selectedContact}
  readOnly
  className="border p-1 mt-2"
/> */}
          <TextField
            select
            fullWidth
            label="Select Service"
            value={appointment.service || ""}
            onChange={(ev) =>
              setappointment((prev) => ({ ...prev, service: ev.target.value }))
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
          >
            <MenuItem value="">Select service</MenuItem>
            {selector.services?.map((el, i) => (
              <MenuItem key={el.service_id} value={el.service_id}>
                {el.service}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            fullWidth
            label="Select Staff"
            value={appointment.staff || ""}
            onChange={(ev) =>
              setappointment((prev) => ({ ...prev, staff: ev.target.value }))
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
          >
            <MenuItem value="">Select staff</MenuItem>
            {selector.staff?.map((el, i) => (
              <MenuItem key={el.staff_id} value={el.staff_id}>
                {el.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            fullWidth
            label="Reason (Optional)"
            value={appointment.reason}
            onChange={(ev) =>
              setappointment((prev) => ({ ...prev, reason: ev.target.value }))
            }
            placeholder="Add a reason"
            variant="outlined"
            multiline
            rows={2}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
          />
          <Box sx={{ display: "flex", gap: 2 }}>
            <DatePicker
              label="Start date"
              fullWidth
              value={appointment.date}
              onChange={(newValue) =>
                setappointment((prev) => ({ ...prev, date: newValue }))
              }
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  variant: "outlined",
                  sx: {
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                    },
                  },
                },
              }}
            />
            <MobileTimePicker
              label="Start time"
              fullWidth
              value={appointment.time}
              onChange={(newValue) =>
                setappointment((prev) => ({ ...prev, time: newValue }))
              }
              format="hh:mm a"
              slotProps={{
                textField: {
                  variant: "outlined",
                  sx: {
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                    },
                  },
                },
              }}
            />
          </Box>
          <TextField
            select
            fullWidth
            label="Duration"
            value={appointment.duration || 15}
            onChange={(ev) =>
              setappointment((prev) => ({ ...prev, duration: ev.target.value }))
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "12px",
              },
            }}
          >
            <MenuItem value={15}>15 mins</MenuItem>
            <MenuItem value={30}>30 mins</MenuItem>
            <MenuItem value={45}>45 mins</MenuItem>
            <MenuItem value={60}>60 mins</MenuItem>
          </TextField>
          <Button
            variant="contained"
            fullWidth
            onClick={onSubmit}
            sx={{
              mt: 1,
              py: 1.5,
              borderRadius: "12px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              fontWeight: 600,
              fontSize: "1rem",
              textTransform: "none",
              "&:hover": {
                background: "linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)",
              },
            }}
          >
            Book Appointment
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export const PatientPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.business);
  const labels = useLabels();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getBusinessPatients(dispatch, selector.details.business_id);
  }, [dispatch, selector.details.business_id]);

  const onSubmit = async (values) => {
    setIsSubmitting(true);
    try {
      await addBusinessPatients(
        dispatch,
        selector.details.business_id,
        values,
        () => {
          // Callback will be called on success
          closePopup();
        }
      );
      // Ensure modal closes after successful creation
      // Use setTimeout to allow any state updates to complete first
      setTimeout(() => {
        closePopup();
      }, 300);
    } catch (error) {
      console.log(error);
      // Error is already handled by the action, don't close on error
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={true}
      onClose={closePopup}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          background: "rgba(255, 255, 255, 0.98)",
          backdropFilter: "blur(20px)",
          maxHeight: "85vh",
          margin: "16px",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          fontWeight: 700,
          fontSize: { xs: "1.125rem", sm: "1.25rem" },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
          px: 2.5,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Add {labels.customer || "Patient"} Details
        </Typography>
        <IconButton
          onClick={closePopup}
          sx={{
            color: "white",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
          }}
        >
          <MdClose size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          pt: 6,
          px: { xs: 2.5, sm: 3 },
          pb: { xs: 2.5, sm: 3 },
          overflow: "visible",
          display: "flex",
          flexDirection: "column",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <Box sx={{ width: "100%", mt: 3 }}>
          <FormikForm
            initialValues={initialValuesAddCustomer}
            fields={feildsAddCustomer()}
            validationSchema={validationSchemaAddCustomer}
            action={(disabled) => (
              <Button
                fullWidth
                variant="contained"
                disabled={disabled || isSubmitting}
                type="submit"
                sx={{
                  mt: 2,
                  py: 1.25,
                  borderRadius: "10px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  textTransform: "none",
                  "&:hover": {
                    background:
                      "linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)",
                  },
                  "&:disabled": {
                    background: "#e0e0e0",
                    color: "#9e9e9e",
                  },
                }}
              >
                {isSubmitting ? `Adding ${labels.customer || "Patient"}...` : `Add ${labels.customer || "Patient"}`}
              </Button>
            )}
            onSubmit={onSubmit}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export const AccountPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.auth);
  const accountState = useSelector((state) => state.account);
  useEffect(() => {
    getAccounts(dispatch, selector?.user?.email);
  }, [selector?.user?.email]);

  console.log(accountState);

  const [typeAccount, settypeAccount] = useState("business");

  return (
    <div className="w-full h-screen z-20 left-0 top-0 fixed bg-black/40 flex items-center justify-center overflow-y-auto p-4">
      <div className="w-[90%] lg:w-[50%] min-h-[60%] max-h-[90%] p-10 bg-white rounded-lg relative">
        <span
          className="absolute right-8 top-4 cursor-pointer"
          onClick={() => closePopup(false)}
        >
          <MdClose />
        </span>
        <h2 className="font-bold text-2xl w-full text-center">Accounts</h2>
        <div className="flex items-center w-full justify-center py-4">
          <p
            className={`flex-1 cursor-pointer text-center border-b-2 ${
              typeAccount === "business" ? "border-b-secondry" : null
            } py-1`}
            onClick={() => settypeAccount("business")}
          >
            Business
          </p>
          <p
            className={`flex-1 cursor-pointer text-center border-b-2 ${
              typeAccount === "staff" ? "border-b-secondry" : null
            } py-1`}
            onClick={() => settypeAccount("staff")}
          >
            Staff
          </p>
        </div>
        <div className="w-full flex overflow-x-hidden flex-1">
          <div
            className={`${
              typeAccount === "business" ? "flex" : "hidden"
            } flex-col gap-2 h-full min-w-full max-h-[500px] overflow-y-scroll`}
          >
            {accountState.businessAccount?.map((e, i) => (
              <div className="flex w-full border-b pb-2 gap-4 items-center">
                <Avatar sx={{ bgcolor: "#2563eb", textTransform: "uppercase" }}>
                  {e?.name?.split("")[0]}
                </Avatar>
                <div className="flex items-start flex-col">
                  <h4>{e?.name}</h4>
                  <div className="flex flex-col items-start gap-2 lg:flex-row lg:items-center">
                    <p className="py-0.5 px-1 rounded-md text-xs text-white bg-blue-500">
                      {e?.contact}
                    </p>
                    <p className="py-0.5 px-1 rounded-md text-xs bg-blue-200">
                      {e?.email}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            className={`${
              typeAccount === "staff" ? "flex" : "hidden"
            } flex-col gap-2 h-full min-w-full max-h-[500px] overflow-y-scroll`}
          >
            {accountState.staffAccount?.map((e, i) => (
              <div className="flex w-full border-b pb-2 gap-4 items-center">
                <Avatar sx={{ bgcolor: "#2563eb", textTransform: "uppercase" }}>
                  {e?.business_name?.split("")[0]}
                </Avatar>
                <div className="flex items-start flex-col">
                  <h4>{e?.business_name}</h4>
                  <div className="flex gap-2">
                    <p className="py-0.5 px-1 rounded-md text-xs text-white bg-blue-500">
                      Role ({e?.role})
                    </p>
                    <p className="py-0.5 px-1 rounded-md text-xs bg-blue-200">
                      Services : {e?.services}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export const ServicePopup = ({ closePopup }) => {
  const selector = useSelector((state) => state.business);
  const selectorAuth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [services, setservices] = useState([
    {
      service: "",
      charges: "",
    },
  ]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitService = async () => {
    if (services.length > 0) {
      let count = 0;
      for (let index = 0; index < services.length; index++) {
        const element = services[index];
        if (element.service === "" || element.charges === "") {
          count++;
        }
      }
      if (count > 0) {
        return;
      }
      setIsSubmitting(true);
      try {
        await addServiceDashboard(
          dispatch,
          services,
          selectorAuth?.user?.business_id
        );
        setservices([
          {
            service: "",
            charges: "",
          },
        ]);
        closePopup();
      } catch (error) {
        console.log(error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  // Check if all previous services have both fields filled
  const canAddMore = () => {
    if (services.length === 0) return true;
    const lastService = services[services.length - 1];
    return (
      lastService.service.trim() !== "" && lastService.charges.trim() !== ""
    );
  };

  return (
    <Dialog
      open={true}
      onClose={closePopup}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          background: "rgba(255, 255, 255, 0.98)",
          backdropFilter: "blur(20px)",
          maxHeight: "85vh",
          margin: "16px",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          fontWeight: 700,
          fontSize: { xs: "1.125rem", sm: "1.25rem" },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
          px: 2.5,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Add Service
        </Typography>
        <IconButton
          onClick={closePopup}
          sx={{
            color: "white",
            "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
          }}
        >
          <MdClose size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          p: { xs: 2, sm: 2.5 },
          overflow: "visible",
          display: "flex",
          flexDirection: "column",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
          }}
        >
          {services.map((e, i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1.5,
                alignItems: { xs: "stretch", sm: "flex-start" },
                p: 1.5,
                borderRadius: "10px",
                backgroundColor: "rgba(102, 126, 234, 0.05)",
                border: "1px solid rgba(102, 126, 234, 0.1)",
              }}
            >
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <InputComponents
                  isRequired={true}
                  message={"Services are required"}
                  placeholder="Enter service"
                  value={e.service}
                  name={"service" + i}
                  onChange={(ev) => {
                    const temp = [...services];
                    temp[i].service = ev.target.value;
                    setservices(temp);
                  }}
                  label={"Service"}
                />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <InputComponents
                  isRequired={true}
                  type={"number"}
                  message={"Charges are required"}
                  placeholder="Enter charges"
                  value={e.charges}
                  name={"charges" + i}
                  onChange={(ev) => {
                    const temp = [...services];
                    temp[i].charges = ev.target.value;
                    setservices(temp);
                  }}
                  label={"Charges"}
                />
              </Box>
              {services.length > 1 && (
                <IconButton
                  onClick={() => {
                    setservices((prev) => prev.filter((el, iv) => iv !== i));
                  }}
                  sx={{
                    backgroundColor: "#f44336",
                    color: "white",
                    "&:hover": { backgroundColor: "#d32f2f" },
                    width: { xs: "100%", sm: 40 },
                    height: { xs: 40, sm: 40 },
                    borderRadius: "8px",
                    minWidth: { xs: "100%", sm: 40 },
                  }}
                >
                  <MdDelete size={18} />
                </IconButton>
              )}
            </Box>
          ))}

          {/* Add Service Button in Content */}
          <Button
            variant="outlined"
            startIcon={<MdAdd />}
            onClick={() => {
              if (canAddMore()) {
                setservices((prev) => [
                  ...prev,
                  {
                    service: "",
                    charges: "",
                  },
                ]);
              }
            }}
            disabled={!canAddMore()}
            fullWidth
            sx={{
              mt: 1,
              py: 1,
              borderRadius: "10px",
              borderColor: "rgba(102, 126, 234, 0.3)",
              color: "#667eea",
              fontWeight: 600,
              fontSize: "0.875rem",
              textTransform: "none",
              "&:hover": {
                borderColor: "#667eea",
                backgroundColor: "rgba(102, 126, 234, 0.05)",
              },
              "&:disabled": {
                borderColor: "#e0e0e0",
                color: "#9e9e9e",
              },
            }}
          >
            Add Another Service
          </Button>
        </Box>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={submitService}
            disabled={isSubmitting}
            sx={{
              px: 3,
              py: 1.25,
              borderRadius: "10px",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              fontWeight: 600,
              fontSize: "0.875rem",
              textTransform: "none",
              minWidth: "180px",
              "&:hover": {
                background: "linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)",
              },
              "&:disabled": {
                background: "#e0e0e0",
                color: "#9e9e9e",
              },
            }}
          >
            {isSubmitting ? "Adding Services..." : "Add Services"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const StaffPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.business);
  const [selectedServices, setselectedServices] = useState([]);
  const [openservice, setopenservice] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getBusinessServices(dispatch, selector.details?.business_id);
  }, []);

  const submitService = async (values) => {
    setIsSubmitting(true);
    try {
      await addStaffDashboard(dispatch, {
        ...values,
        services: selectedServices.join(","),
      });
      closePopup();
    } catch (error) {
      console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const openServiceDrop = () => {
    setopenservice((prev) => !prev);
  };

  return (
    <>
      {/* Service Selection Dialog */}
      <Dialog
        open={openservice}
        onClose={openServiceDrop}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            background: "rgba(255, 255, 255, 0.98)",
            backdropFilter: "blur(20px)",
            maxHeight: "90vh",
            margin: "16px",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            fontWeight: 700,
            fontSize: { xs: "1.25rem", sm: "1.5rem" },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2.5,
            px: 3,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Select Services
          </Typography>
          <IconButton
            onClick={openServiceDrop}
            sx={{
              color: "white",
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
            }}
          >
            <MdClose size={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            p: 2,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1.5,
                borderRadius: "8px",
                backgroundColor: "rgba(102, 126, 234, 0.1)",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "rgba(102, 126, 234, 0.15)",
                },
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "0.875rem" }}>
                Select All
              </Typography>
              <input
                checked={
                  selectedServices.length === selector.services?.length &&
                  selector.services?.length > 0
                }
                onChange={(ev) => {
                  if (Array.isArray(selector.services)) {
                    if (selectedServices.length === selector.services?.length) {
                      setselectedServices([]);
                    } else {
                      setselectedServices(
                        selector.services?.map((e) => e.service_id)
                      );
                    }
                  } else {
                    setselectedServices([]);
                  }
                }}
                type="checkbox"
                style={{
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                }}
              />
            </Box>
            <Box
              sx={{
                maxHeight: "300px",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 1,
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              {selector.services?.map((e, i) => (
                <Box
                  key={i}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    borderRadius: "8px",
                    backgroundColor: selectedServices.includes(e.service_id)
                      ? "rgba(102, 126, 234, 0.15)"
                      : "rgba(0, 0, 0, 0.02)",
                    border: selectedServices.includes(e.service_id)
                      ? "2px solid #667eea"
                      : "1px solid rgba(0, 0, 0, 0.1)",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    "&:hover": {
                      backgroundColor: selectedServices.includes(e.service_id)
                        ? "rgba(102, 126, 234, 0.2)"
                        : "rgba(102, 126, 234, 0.05)",
                    },
                  }}
                  onClick={() => {
                    if (selectedServices.includes(e.service_id)) {
                      setselectedServices((prev) =>
                        prev.filter((el) => el !== e.service_id)
                      );
                    } else {
                      setselectedServices((prev) => [...prev, e.service_id]);
                    }
                  }}
                >
                  <Typography sx={{ fontWeight: 500, fontSize: "0.875rem" }}>
                    {e.service}
                  </Typography>
                  <input
                    checked={selectedServices.includes(e.service_id)}
                    onChange={() => {}}
                    type="checkbox"
                    style={{
                      width: "18px",
                      height: "18px",
                      cursor: "pointer",
                    }}
                  />
                </Box>
              ))}
            </Box>
            <Button
              variant="contained"
              onClick={openServiceDrop}
              fullWidth
              sx={{
                mt: 1,
                py: 1,
                borderRadius: "8px",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                fontWeight: 600,
                fontSize: "0.875rem",
                textTransform: "none",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)",
                },
              }}
            >
              Done
            </Button>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Main Add Staff Dialog */}
      <Dialog
        open={true}
        onClose={closePopup}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "24px",
            background: "rgba(255, 255, 255, 0.98)",
            backdropFilter: "blur(20px)",
            maxHeight: "90vh",
            margin: "16px",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "white",
            fontWeight: 700,
            fontSize: { xs: "1.25rem", sm: "1.5rem" },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2.5,
            px: 3,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            Add Staff
          </Typography>
          <IconButton
            onClick={closePopup}
            sx={{
              color: "white",
              "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" },
            }}
          >
            <MdClose size={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            pt: 6,
            px: { xs: 3, sm: 4 },
            pb: { xs: 3, sm: 4 },
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "& .MuiFormControl-root:first-of-type": {
              mt: 0,
            },
          }}
        >
          <Box sx={{ width: "100%", mt: 2 }}>
            <FormikForm
              initialValues={initialValuesAddStaff}
              fields={feildsAddStaff([
                {
                  value: "admin",
                  label: "Admin",
                  disabled: false,
                },
                {
                  value: "staff",
                  label: "Staff",
                  disabled: false,
                },
              ])}
              validationSchema={validationSchemaAddStaff}
              extra_element={
                <Box
                  onClick={openServiceDrop}
                  sx={{
                    cursor: "pointer",
                    mb: 2,
                    p: 2,
                    borderRadius: "12px",
                    backgroundColor: "rgba(102, 126, 234, 0.05)",
                    border: "2px dashed rgba(102, 126, 234, 0.3)",
                    transition: "all 0.2s",
                    "&:hover": {
                      backgroundColor: "rgba(102, 126, 234, 0.1)",
                      borderColor: "rgba(102, 126, 234, 0.5)",
                    },
                  }}
                >
                  <InputComponents
                    disabled={true}
                    placeholder={`Selected services (${
                      selectedServices.length
                    }/${selector.services?.length || 0})`}
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      mt: 0.5,
                      color: "rgba(102, 126, 234, 0.7)",
                      fontSize: "0.75rem",
                    }}
                  >
                    Click to select services
                  </Typography>
                </Box>
              }
              action={(disabled) => (
                <Button
                  fullWidth
                  variant="contained"
                  disabled={disabled || isSubmitting}
                  type="submit"
                  sx={{
                    mt: 2,
                    py: 1.5,
                    borderRadius: "12px",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    fontWeight: 600,
                    fontSize: "1rem",
                    textTransform: "none",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)",
                    },
                    "&:disabled": {
                      background: "#e0e0e0",
                      color: "#9e9e9e",
                    },
                  }}
                >
                  {isSubmitting ? "Adding Staff..." : "Add Staff"}
                </Button>
              )}
              onSubmit={submitService}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

const Setupcard = ({
  title,
  description,
  isCompleted,
  // route,
  onClick,
  btnText,
  count,
  disabled,
}) => {
  return (
    <article className="flex items-center gap-4">
      <figure
        className={`w-16 h-16 rounded-full border ${
          disabled ? "border-gray-500" : "border-primary"
        } ${
          isCompleted ? "bg-primary" : "bg-gray-300"
        } flex items-center justify-center`}
      >
        <span
          className={`font-semibold text-2xl ${
            disabled
              ? "text-gray-500"
              : isCompleted
              ? "text-white"
              : "text-primary"
          }`}
        >
          {count}
        </span>
      </figure>
      <section className="flex flex-col gap-1">
        <section className="flex w-full gap-2 items-center">
          <h4 className="font-bold text-lg">{title}</h4>
          {isCompleted ? (
            <p
              className={`p-1 w-fit border-2 border-primary rounded text-primary text-sm`}
            >
              Completed
            </p>
          ) : (
            <></>
          )}
        </section>
        <p className="font-normal text-sm">{description}</p>
        {
          isCompleted ? (
            <p className="p-2"> </p>
          ) : (
            <button
              className="button w-40 text-sm !p-2"
              disabled={disabled}
              onClick={onClick}
            >
              {btnText}
            </button>
          )
          //  <p>start</p>
          // <Link href={route}><span className='text-primary underline'>Let&apos;s start</span></Link>
        }
      </section>
    </article>
  );
};

export default Home;
